import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/product/depots?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/product/depots/${id}`, { params });
}

export async function create(body) {
  return request(`/product/depots`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/product/depots/${id}`, {
    method: 'POST',
    body,
  });
}

export async function importProduct(body) {
  return request(`/product/products-import`, {
    method: 'POST',
    body
  })
}

export async function syncOne(params, id, partner_id) {
  return request(`/product/sync-depot/depot/${id}/partner/${partner_id}`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}